import { render, staticRenderFns } from "./SubscriptionDetail.vue?vue&type=template&id=7208b328&scoped=true&"
import script from "./SubscriptionDetail.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7208b328",
  null
  
)

export default component.exports